import { HttpClient } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { BehaviorSubject, Observable } from 'rxjs'
import { takeUntil } from 'rxjs/operators'
import { ResponseModel } from '../../domain/authentication.model'
import { BaseGetModel } from '../../domain/base-get-model'
import { ITrack } from '../../Interface/track'
import { CoreEnvironmentService } from '../core-environment.service'
import { DestroyService } from '../destroy.service'
import { Widget } from './widgets-api.type'

@Injectable({
  providedIn: 'root'
})
export class WidgetsApiService {
  private readonly coreEnvironmentService = inject(CoreEnvironmentService)
  private readonly destroy$ = inject(DestroyService)
  private readonly http = inject(HttpClient)

  widgetById$ = new BehaviorSubject<Widget>(null)

  private readonly baseUrl: string = this.coreEnvironmentService.getBeatmakerApiBaseUrl()
  private readonly widgetBaseEndpoint = '/api/widgets'
  private readonly widgetsUrls: Record<'widgetsUrl', string> = {
    widgetsUrl: `${this.baseUrl}${this.widgetBaseEndpoint}`
  }
  private readonly httpOptions = { withCredentials: true }

  getWidgetById(widgetId: number) {
    const url = `${this.widgetsUrls.widgetsUrl}/${widgetId}`

    this.http
      .get<Widget>(url)
      .pipe(takeUntil(this.destroy$))
      .subscribe(widget => {
        this.widgetById$.next(widget)
      })
  }

  getWidgetBeats({ widgetId, page }: { widgetId: number; page: number }): Observable<BaseGetModel<ITrack>> {
    const url = `${this.widgetsUrls.widgetsUrl}/${widgetId}/beats?pageNo=${page}`

    return this.http.get<BaseGetModel<ITrack>>(url)
  }

  updateWidget({ widget, colors }: { widget: Widget; colors: string }): Observable<ResponseModel> {
    const url = `${this.widgetsUrls.widgetsUrl}/${widget.id}`
    const payload = { ...widget, colors }

    return this.http.put<ResponseModel>(url, payload, this.httpOptions)
  }
}
